import React, { useState, useEffect } from "react";
import NavBar from "./NavBar";
import SideBar from "./SideBar";
import { useSearchParams, useParams } from "react-router-dom";
import clinicService from "../../services/clinic.service";
import PageLoading from "../common/PageLoading";
const UnsubscribePage = () => {
  let { clinicId } = useParams();
  const [searchParams] = useSearchParams();
  const [clinic, setClinic] = useState();
  const [patientID, setPatientID] = useState(0);
  const [patientUUID, setPatientUUID] = useState("0");
 const [utype, setUtype] = useState(0);
  const [udata, setUdata] = useState();

 const [success,setSuccess] = useState();

  useEffect(() => {
    setPatientID(searchParams.get("p"));
    setPatientUUID(searchParams.get("u"));
    setUtype(searchParams.get("type"));
    setUdata(searchParams.get("data"));
    //console.log("sending api requiest");
    const pid = searchParams.get("p");
    const uid = searchParams.get("u");
    const urlType = searchParams.get("type");
    const urlData = searchParams.get("data");

    clinicService
      .getClinicByShortCode(clinicId)
      .then((res) => {
        setClinic(res.data);
        //console.log(res.data);
        clinicService.unsubscribe(res.data.ID,pid,uid,urlType,urlData)
        .then(res2=>{
            setSuccess(true)
           // console.log(res2)
        })
        .catch(err=>{
            console.log(err)
        })
      
      })
      .catch((err) => {
        console.log(err);
      });
   // console.log("sending api request");
  }, []);

  return (
    <>
      {clinic && (
        <div>
          <NavBar clinic={clinic} />
          <div className="container">
            <div className="row">
              <div className="col-lg-9 order-lg-last">
                <div className="m-4">
                    {success &&
                    <h1>You have been unsubscribed and will no longer hear from us. </h1>
                    }
                </div>
                    
              </div>
              <div className="col-lg-3">
                <SideBar clinic={clinic} />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UnsubscribePage;
